export default __webpack_public_path__ + "phoenix-logo-icon-grayscale@2x.png";